import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { tableHeaders } from '@components/unable-emails-modal/unable-emails-modal.constants';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NotificationServerSettingsService } from '@services';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent, TableCellDirective, TableGridComponent, TextEllipsisComponent } from 'mbs-ui-kit';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { HelpLinkDirective } from 'mbs-ui-shared@help/helpLink.directive';
import { BouncedEmail, BounceType } from 'mbs-ui-shared@models/Notification';
import { finalize } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'mbs-unable-deliver-emails-modal',
  templateUrl: './unable-emails-modal.component.html',
  imports: [ButtonComponent, I18NextPipe, ModalComponent, TableCellDirective, TableGridComponent, TextEllipsisComponent, HelpLinkDirective]
})
export class UnableEmailsModalComponent implements OnInit {
  serverSettingsService = inject(NotificationServerSettingsService);
  private i18n = inject(I18NextPipe);
  private router = inject(Router);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public loading = true;
  public removeLoading = false;

  public emails: Array<BouncedEmail>;

  public readonly headers = tableHeaders(this.i18n);

  ngOnInit() {
    this.setBounseList();
  }

  public redirectToLogs(email: string) {
    const navigateToErrors = () => {
      this.router.navigate([RoutingPath.NotificationErrors], {
        queryParams: {
          search: `To Email: ${email}`
        }
      });
    };

    if (this.router.url.includes(RoutingPath.NotificationErrors)) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        navigateToErrors();
      });
    } else {
      navigateToErrors();
    }

    this.baseModal.save();
  }

  public getReason(reason: BounceType): string {
    const texts = {
      [BounceType.PermanentBounce]: this.i18n.transform('shared:unable-emails-modal.labels.permanentBounce'),
      [BounceType.TransientBounce]: this.i18n.transform('shared:unable-emails-modal.labels.transientBounce'),
      [BounceType.Complaint]: this.i18n.transform('shared:unable-emails-modal.labels.complaint')
    };

    return this.i18n.transform('shared:unable-emails-modal.labels.emailRejected', { reason: texts[reason] });
  }

  public removeFromBounceList(email: string) {
    this.removeLoading = true;
    this.serverSettingsService
      .removeFromBounceList(email)
      .pipe(finalize(() => (this.removeLoading = false)))
      .subscribe(() => {
        this.setBounseList();
      });
  }

  private setBounseList() {
    this.loading = true;
    this.serverSettingsService
      .getBounceList()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((emails) => {
        this.emails = emails.data;
      });
  }
}
